
const ContactInfo = () => {
  return (
    <address>
      I'm Your Huckleberry LLC
      <br />
      Email:{' '}
      <a href="mailto:katie@huckleberrycleaning.com">
        katie@huckleberrycleaning.com
      </a>
      <br />
      Phone: <a href="tel:+17156518170">715-651-8170</a>
      <br />
      Mailing Address: 1900 Babcock Avenue, Cumberland, WI 54829
    </address>
  );
};

export default ContactInfo;